import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { InlineSVGModule } from "ng-inline-svg-2";
import { SharedModule } from "../../../../../shared/shared.module";
import { ThemeModeSwitcherComponent } from "./theme-mode-switcher.component";

@NgModule({
  declarations: [ThemeModeSwitcherComponent],
  imports: [CommonModule, InlineSVGModule, SharedModule],
  exports: [ThemeModeSwitcherComponent],
})
export class ThemeModeModule {}
